import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-zentra-bg" data-testid="auth-loading">
                <div className="flex flex-col items-center gap-3">
                    <div className="w-10 h-10 border-2 border-zentra-primary border-t-transparent rounded-full animate-spin" />
                    <p className="text-sm text-zentra-muted">Validando sesión…</p>
                </div>
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" replace />;
    }
    if (roles && roles.length > 0 && !roles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }
    return children;
}
